// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader__dt4zX {
  background-color: #fff;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 100000;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 1;
  text-align: center;
}
.loader__dt4zX.fullScreen__hUrXR {
  position: fixed;
}
.loader__dt4zX .warpper__Ft8Ob {
  width: 100px;
  height: 100px;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-around;
}
.loader__dt4zX .inner___ICZD {
  width: 40px;
  height: 40px;
  margin: 0 auto;
  text-indent: -12345px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  border-right: 1px solid rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  border-left: 1px solid rgba(0, 0, 0, 0.7);
  border-radius: 50%;
  z-index: 100001;
}
.loader__dt4zX .inner___ICZD {
  animation: spinner__UsmTP 600ms infinite linear;
}
.loader__dt4zX .text__eN4YK {
  white-space: nowrap;
  width: 100px;
  height: 20px;
  text-align: center;
  font-size: 12px;
  letter-spacing: 4px;
  color: #000;
  display: flex;
  /* Add this line */
  align-items: center;
  /* Add this line */
  justify-content: center;
  /* Add this line */
}
.loader__dt4zX.hidden__mu2Ua {
  z-index: -1;
  opacity: 0;
  transition: opacity 1s ease 0.5s, z-index 0.1s ease 1.5s;
}
@keyframes spinner__UsmTP {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=Loader.module.css.map */`, "",{"version":3,"sources":["webpack://./Loader.module.less","webpack://./src/Components/Loader/Loader.module.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;ACCF;ADCE;EACE,eAAA;ACCJ;ADhBA;EAmBI,YAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,6BAAA;ACAJ;ADvBA;EA2BI,WAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,yCAAA;EACA,2CAAA;EACA,4CAAA;EACA,yCAAA;EACA,kBAAA;EACA,eAAA;ACDJ;ADnCA;EAuCM,+CAAA;ACDN;ADtCA;EA4CI,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;ECHF,kBAAkB;EDIhB,mBAAA;ECFF,kBAAkB;EDGhB,uBAAA;ECDF,kBAAkB;AACpB;ADGE;EACE,WAAA;EACA,UAAA;EACA,wDAAA;ACDJ;ADIA;EACE;IACE,uBAAA;ECFF;EDKA;IACE,yBAAA;ECHF;AACF;AACA,4CAA4C","sourcesContent":[".loader {\n  background-color: #fff;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 100000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 1;\n  text-align: center;\n\n  &.fullScreen {\n    position: fixed;\n  }\n\n  .warpper {\n    width: 100px;\n    height: 100px;\n    display: inline-flex;\n    flex-direction: column;\n    justify-content: space-around;\n  }\n\n  .inner {\n    width: 40px;\n    height: 40px;\n    margin: 0 auto;\n    text-indent: -12345px;\n    border-top: 1px solid rgba(0, 0, 0, 0.08);\n    border-right: 1px solid rgba(0, 0, 0, 0.08);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n    border-left: 1px solid rgba(0, 0, 0, 0.7);\n    border-radius: 50%;\n    z-index: 100001;\n\n    :local {\n      animation: spinner 600ms infinite linear;\n    }\n  }\n\n  .text {\n    white-space: nowrap;\n    width: 100px;\n    height: 20px;\n    text-align: center;\n    font-size: 12px;\n    letter-spacing: 4px;\n    color: #000;\n    display: flex; /* Add this line */\n    align-items: center; /* Add this line */\n    justify-content: center; /* Add this line */\n  }\n\n  &.hidden {\n    z-index: -1;\n    opacity: 0;\n    transition: opacity 1s ease 0.5s, z-index 0.1s ease 1.5s;\n  }\n}\n@keyframes spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}",".loader {\n  background-color: #fff;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 100000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 1;\n  text-align: center;\n}\n.loader.fullScreen {\n  position: fixed;\n}\n.loader .warpper {\n  width: 100px;\n  height: 100px;\n  display: inline-flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n.loader .inner {\n  width: 40px;\n  height: 40px;\n  margin: 0 auto;\n  text-indent: -12345px;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n  border-right: 1px solid rgba(0, 0, 0, 0.08);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  border-left: 1px solid rgba(0, 0, 0, 0.7);\n  border-radius: 50%;\n  z-index: 100001;\n}\n.loader .inner :local {\n  animation: spinner 600ms infinite linear;\n}\n.loader .text {\n  white-space: nowrap;\n  width: 100px;\n  height: 20px;\n  text-align: center;\n  font-size: 12px;\n  letter-spacing: 4px;\n  color: #000;\n  display: flex;\n  /* Add this line */\n  align-items: center;\n  /* Add this line */\n  justify-content: center;\n  /* Add this line */\n}\n.loader.hidden {\n  z-index: -1;\n  opacity: 0;\n  transition: opacity 1s ease 0.5s, z-index 0.1s ease 1.5s;\n}\n@keyframes spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n/*# sourceMappingURL=Loader.module.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `loader__dt4zX`,
	"fullScreen": `fullScreen__hUrXR`,
	"warpper": `warpper__Ft8Ob`,
	"inner": `inner___ICZD`,
	"spinner": `spinner__UsmTP`,
	"text": `text__eN4YK`,
	"hidden": `hidden__mu2Ua`
};
export default ___CSS_LOADER_EXPORT___;
